const React = require("react");
const T = React.PropTypes;

const baseStyle = {
    textAlign: "center"
};

const TitledMessage = React.createClass({
    propTypes: {
        style: T.object,
        Title: T.string,
        Subtitle: T.string,
        children: T.node
    },
    getDefaultProps() {
        return {
            style: {}
        };
    },
    render() {
        const style = Object.assign({}, baseStyle, this.props.style);

        let title = null;
        let subtitle = null;

        if (this.props.Title) {
            title = (<h1>{this.props.Title}</h1>);
        }

        if (this.props.Subtitle) {
            subtitle = (<h3>{this.props.Subtitle}</h3>);
        }

        let result = (<div style={style}>
            {title}
            {subtitle}
            {this.props.children}
        </div>);

        return result;
    }
});

module.exports = TitledMessage


// WEBPACK FOOTER //
// ./src/components/TitledMessage.jsx